import {
  FluentProvider,
  Theme,
  makeStyles,
  mergeClasses,
  shorthands,
  webLightTheme,
} from "@fluentui/react-components";
import React from "react";

const useStyles = makeStyles({
  provider: {
    ...shorthands.margin(0),
    ...shorthands.borderWidth("1px"),
    width: "100%",
  },
  text: {
    fontSize: "14px",
  },
  mainWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    fontFamily: "var(--ludvig-font-family)",
  },
  components: {},
  spacing: {},
});

export const customLightTheme: Theme = {
  ...webLightTheme,
  colorBrandForeground1: "var(--primary)",
  colorBrandForeground2: "var(--primaryLight)",
  colorBrandStroke1: "var(--primary)",
  colorBrandStroke2: "var(--primaryLight)",
  colorNeutralForeground2BrandSelected: "var(--primary)",
};

export function LudvigThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const styles = useStyles();
  return (
    <FluentProvider
      className={mergeClasses(styles.provider, styles.text)}
      theme={customLightTheme}
      // Inline style is needed here, adding height through useStyles hook messes up fluent UI components such as Dropdown, Combobox
      style={{ height: "100%", backgroundColor: "var(--background)" }}
    >
      <div id="main-wrapper" className={styles.mainWrapper}>
        {children}
      </div>
      
    </FluentProvider>
  );
}
